"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAddressDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
class UpdateAddressDto {
}
exports.UpdateAddressDto = UpdateAddressDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "ID of the address",
        required: false,
        example: 312,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateAddressDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Type of the address",
        required: false,
        example: 25,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Address Type ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateAddressDto.prototype, "addressTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Address line 1",
        required: false,
        example: "123 Main St",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Address must be a string." }),
    (0, class_validator_1.MaxLength)(255, { message: "Address must not exceed 255 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], UpdateAddressDto.prototype, "address1", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Address line 2",
        required: false,
        example: "Suite 400",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Address 2 must be a string." }),
    (0, class_validator_1.MaxLength)(255, { message: "Address 2 must not exceed 255 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], UpdateAddressDto.prototype, "address2", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Area of the address",
        required: false,
        example: "Downtown",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Area must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "Area must not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], UpdateAddressDto.prototype, "area", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Pin code of the address",
        required: false,
        example: "12345",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Postal code must be a string." }),
    (0, class_validator_1.Matches)(/^[A-Za-z0-9\s\-]{3,10}$/, {
        message: "Postal code must be 3-10 characters long and can only contain letters, numbers, spaces, and hyphens.",
    }),
    tslib_1.__metadata("design:type", String)
], UpdateAddressDto.prototype, "pinCode", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Phone number associated with the address",
        required: false,
        example: "1234567890",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Phone number must be a string." }),
    (0, class_validator_1.Matches)(/^[0-9]{10}$/, {
        message: "Phone number must be a valid 10-digit number.",
    }),
    tslib_1.__metadata("design:type", String)
], UpdateAddressDto.prototype, "phoneNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Alternate phone number",
        required: false,
        example: "0987654321",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Alternate Phone number must be a string." }),
    tslib_1.__metadata("design:type", String)
], UpdateAddressDto.prototype, "alternatePhoneNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Email associated with the address",
        required: false,
        example: "email@example.com",
    }),
    (0, class_validator_1.IsOptional)()
    // @IsEmail({}, { message: "Invalid email format." })
    ,
    tslib_1.__metadata("design:type", String)
], UpdateAddressDto.prototype, "email", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Support number",
        required: false,
        example: "1234567890",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Support number must be a string." }),
    tslib_1.__metadata("design:type", String)
], UpdateAddressDto.prototype, "supportNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Country ID",
        required: false,
        example: 1,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Country ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateAddressDto.prototype, "countryId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "State ID",
        required: false,
        example: 2,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "State ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateAddressDto.prototype, "stateId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "City ID",
        required: false,
        example: 3,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "City ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateAddressDto.prototype, "cityId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Updated by must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateAddressDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Updated at must be a string." }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], UpdateAddressDto.prototype, "updatedAt", void 0);
